var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCampaignIcon2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.58333 1.66699C3.43274 1.66699 2.5 2.59973 2.5 3.75033V18.3337L6.14583 16.2503L9.79167 18.3337L13.4375 16.2503L17.0833 18.3337V3.75033C17.0833 2.59973 16.1506 1.66699 15 1.66699H4.58333ZM7.1875 4.79199C6.32455 4.79199 5.625 5.49155 5.625 6.35449C5.625 7.21744 6.32455 7.91699 7.1875 7.91699C8.05045 7.91699 8.75 7.21744 8.75 6.35449C8.75 5.49155 8.05045 4.79199 7.1875 4.79199ZM13.6532 5.09709C13.2464 4.69029 12.5869 4.69029 12.1801 5.09709L5.9301 11.3471C5.5233 11.7539 5.5233 12.4134 5.9301 12.8202C6.33689 13.227 6.99644 13.227 7.40324 12.8202L13.6532 6.57023C14.06 6.16343 14.06 5.50389 13.6532 5.09709ZM12.3958 10.0003C11.5329 10.0003 10.8333 10.6999 10.8333 11.5628C10.8333 12.4258 11.5329 13.1253 12.3958 13.1253C13.2588 13.1253 13.9583 12.4258 13.9583 11.5628C13.9583 10.6999 13.2588 10.0003 12.3958 10.0003Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignIcon2);
export default __webpack_public_path__ + "static/media/campaign-icon-2.a576db198471c0aaf82aa80c1744f6ec.svg";
export { ForwardRef as ReactComponent };